import React, {useContext} from "react"
import {useState} from "react";
import {Card, Divider, Empty, Typography} from "antd"
import {TypeViagem} from "../../../../../Models/Domain/Viagem/Viagem";
import {ListagemDeViagensDaEscola} from "../../../../Components/Viagem/Escola/ListagemDeViagensDaEscola";
import {Navigate, Route, Routes, useMatch, useNavigate, useResolvedPath} from "react-router-dom";
import {SessaoARContext} from "../../../../Contexts/SessaoContext";
import {EnumTipoUsuario, SessaoARDaEscola} from "../../../../../Models/Domain/AreaRestrita/Sessao";
import {InscricoesDaViagem} from "../../../../../Views/Viagem/Cadastros/Viagem/Inscricoes";

export const ViagemParaTipoEscola: React.FC<{}> = () => {

    const id = useMatch(useResolvedPath(":id/inscricoes").pathname)?.params.id ?? undefined;
    const index = useResolvedPath("").pathname
    
    const SessaoAR = useContext(SessaoARContext);
    const navigate = useNavigate();

    const [viagemEmAlteracao, setViagemEmAlteracao] = useState<TypeViagem | undefined>(
        (() => {
            const escola = (SessaoAR?.sessao as SessaoARDaEscola)?.info;
            const v = escola?.viagens?.find((v) => v.codigo == id);
            if(v != undefined){
                v.escola = escola
            }

            return v
        })()
    );

    if (SessaoAR?.sessao?.tipoDeUsuario !== EnumTipoUsuario.Escola) return <Empty description="A sessão atual da Area Restrita não é uma sessão do tipo escola" />

    return <React.Fragment>
        <Card style={{minHeight: "100%"}}>

            <Typography>
                <Typography.Title level={4} style={{margin: 0}}> Suas viagens </Typography.Title>
            </Typography>

            <Divider />

            <Routes>
                <Route key="viagens" index element={

                    <ListagemDeViagensDaEscola
                        hrefDoBotaoInscricoes={(item) => {
                            if (item.codigo) {
                                return `/viagens/${item.codigo}/inscricoes/`
                            }
                        }}

                        aoSelecionarInscricoes={(item) => {
                            if (item.codigo) {
                                setViagemEmAlteracao(item)
                            }
                            
                        }}
                    />
                } />

                <Route key="inscricoes" path=":id/inscricoes" element={
                    viagemEmAlteracao == undefined ? 
                        <Navigate to={index} /> :
                        <InscricoesDaViagem privilegio="escola" viagem={viagemEmAlteracao} retornar={() => navigate(index)} />
                } />

                <Route path='*' element={<Navigate to={index} />} />
            </Routes>

        </Card>
    </React.Fragment>
}
